import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PackVerification_ds_get_completed_pack_verification_task_by_serialNumberIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { serialNumberId: number, shipmentId?: number }): 
  Promise<{ result: { Id?: number, ActualSourceShippingContainerId?: number, ChainHead?: number, ShipmentId?: number, StatusId?: number, ParentTask?: { Id?: number, StatusId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumberId)) {
      missingRequiredInParams.push('\'serialNumberId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_completed_pack_verification_task_by_serialNumberId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { serialNumberId: number, shipmentId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualSourceShippingContainerId?: number, ChainHead?: number, ShipmentId?: number, StatusId?: number, ParentTask?: { Id?: number, StatusId?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumberId)) {
      missingRequiredInParams.push('\'serialNumberId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_completed_pack_verification_task_by_serialNumberId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { serialNumberId: number, shipmentId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualSourceShippingContainerId?: number, ChainHead?: number, ShipmentId?: number, StatusId?: number, ParentTask?: { Id?: number, StatusId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumberId)) {
      missingRequiredInParams.push('\'serialNumberId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_completed_pack_verification_task_by_serialNumberId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      serialNumberId: number, shipmentId?: number    }) {
        if(isNil(inParams.serialNumberId)) {
          return true; 
        }
      return false;
    }
}
